// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var CustomerListController = function ($scope, Customer, gettextCatalog, gettext) {
    $scope.wasSearching = false;
    $scope.updateFilter = function () {
        $scope.customers = $scope.paginator(function (options, callback) {
            return Customer.query(options, function () { callback(); $scope.wasSearching = options.search; });
        }, { StatusFilter: 'Normal', search: $scope.filter }, 20);
    };
    $scope.filter = "";
    $scope.updateFilter();

    $scope.deleteCustomer = function (customerId) {
        $scope.yesCancel(gettextCatalog.getString(gettext('Delete Customer')), gettextCatalog.getString(gettext('Are you sure?')), function () { Customer.remove({ customerId: customerId }, $scope.updateFilter); });
    };
};
CustomerListController.$inject = ['$scope', 'Customer', 'gettextCatalog', 'gettext'];
